import React from 'react';

const ArticleSkeleton = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto animate-pulse">
      {/* Main Title */}
      <div className="mb-8">
        <div className="h-8 bg-gray-200 rounded w-3/4 mb-2"></div>
        <div className="h-8 bg-gray-200 rounded w-1/2"></div>
      </div>

      {/* Introduction Paragraph */}
      <div className="mb-8">
        <div className="h-4 bg-gray-200 rounded w-full mb-3"></div>
        <div className="h-4 bg-gray-200 rounded w-full mb-3"></div>
        <div className="h-4 bg-gray-200 rounded w-4/5 mb-3"></div>
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
      </div>

      {/* Subtitle */}
      <div className="mb-6">
        <div className="h-6 bg-gray-200 rounded w-1/3"></div>
      </div>

      {/* Second Paragraph */}
      <div className="mb-8">
        <div className="h-4 bg-gray-200 rounded w-full mb-3"></div>
        <div className="h-4 bg-gray-200 rounded w-full mb-3"></div>
        <div className="h-4 bg-gray-200 rounded w-5/6 mb-3"></div>
        <div className="h-4 bg-gray-200 rounded w-2/3"></div>
      </div>
    </div>
  );
};

export default ArticleSkeleton;